<template>
  <v-dialog v-model="showDialog" persistent>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" @click="cargar">Agregar</v-btn>
    </template>
    <v-card>
      <v-card-title> Nuevo reparto {{ generacionId }} </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-text-field
            type="text"
            label="Nombre"
            v-model="nombre"
            :rules="[rules.required]"
          />
          <v-text-field
            type="text"
            label="VPS"
            v-model="vps"
            :rules="[rules.required]"
          />
          <v-autocomplete
            v-model="asignacionId"
            :items="asiganciones"
            item-text="nombre"
             item-value="id"
            dense
            filled
            label="Asignaciones"
            :rules="[rules.required]"
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <span class="red--text">{{ errorMessage }}</span>
      <v-card-actions>
        <v-btn small @click="showDialog = false">VOLVER</v-btn>
        <v-btn small color="primary" @click="guardar" :disabled="!validForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";

export default {
  props: ['generacionId'],
  data() {
    return {
      nombre: "",
      vps: "",
      showDialog: false,
      errorMessage: "",
      asiganciones: [],
      asignacionId: null,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
      validForm: false,
    };
  },
  methods: {
    cargar() {

      this.errorMessage = "";

      axios
        .get("/asignacion")
        .then((response) => {
          this.asiganciones = response.data;
        })
        .catch((err) => {
          console.log(err);
        });

    },
    guardar() {

      this.errorMessage = "";

      let rep = {
        nombre: this.nombre,
        vps: this.vps,
        asignacion: { id: this.asignacionId },
        generacion: { id: this.generacionId },
      };
      console.log("agregar clicked", rep);
      axios
        .put("/repartos", rep)
        .then((response) => {
          console.log(response);
          this.$emit("agregado", response.data);
          this.$refs.form.reset();
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
  },
};
</script>